import React from 'react'

const FileUploadErrorMessage = () => (
  <div className="files__list-rejected">
    <p>
      Attenzione: uno dei file che hai selezionato ha un formato non valido. I
      formati consentiti sono: .jpg, .png, .pdf - 50Mb
    </p>
  </div>
)

export default FileUploadErrorMessage
